module.exports = __webpack_public_path__ + "img/measure_button.e86859f6.png";